var map = {
	"./personalI.json": 204,
	"./personalII.json": 205,
	"./personalIII.json": 206,
	"./workI.json": 207,
	"./workII.json": 208,
	"./workIII.json": 209
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;



//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\.json$
// module id = 218
// module chunks = 2